var map = {
	"./avatar-sammy-base-full.png": 98571,
	"./avatar-sammy-dino-full.png": 61777,
	"./avatar-sammy-fall-full.png": 76401,
	"./avatar-sammy-smoothie-full.png": 67107,
	"./avatar-sammy-space-full.png": 15330,
	"./avatar-sammy-spring-full.png": 65269,
	"./avatar-sammy-summer-full.png": 78235,
	"./avatar-sammy-winter-full.png": 53260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11119;